export const senateStates = [
    {'AK': 'Alaska - AK'},
    {'AL': 'Alabama - AL'},
    {'CO': 'Colorado - CO'},
    {'CT': 'Connecticut - CT'},
    {'GA': 'Georgia - GA'},
    {'IN': 'Indiana - IN'},
    {'KS': 'Kansas - KS'},
    {'KY': 'Kentucky - KY'},
    {'LA': 'Louisiana - LA'},
    {'MA': 'Massachusetts - MA'},
    {'ME': 'Maine - ME'},
    {'MN': 'Minnesota - MN'},
    {'NC': 'North Carolina - NC'},
    {'NH': 'New Hampshire - NH'},
    {'PA': 'Pennsylvania - PA'},
    {'RI': 'Rhode Island - RI'},
    {'SC': 'South Carolina - SC'},
    {'TN': 'Tennessee - TN'},
    {'UT': 'Utah - UT'},
    {'VA': 'Virginia - VA'},
    {'VT': 'Vermont - VT'},
    {'WA': 'Washington - WA'},
    {'WI': 'Wisconsin - WI'},
    {'WY': 'Wyoming - WY'}
  ]

export const houseStates = [
    {'AL': 'Alabama - AL'},
    {'AZ': 'Arizona - AZ'},
    {'CA': 'California - CA'},
    {'CO': 'Colorado - CO'},
    {'CT': 'Connecticut - CT'},
    {'DE': 'Delaware - DE'},
    {'FL': 'Florida - FL'},
    {'GA': 'Georgia - GA'},
    {'IL': 'Illinois - IL'},
    {'IN': 'Indiana - IN'},
    {'KS': 'Kansas - KS'},
    {'KY': 'Kentucky - KY'},
    {'MI': 'Michigan - MI'},
    {'MN': 'Minnesota - MN'},
    {'MP': 'Northern Mariana Islands - MP'},
    {'NC': 'North Carolina - NC'},
    {'NH': 'New Hampshire - NH'},
    {'NJ': 'New Jersey - NJ'},
    {'NY': 'New York - NY'},
    {'OH': 'Ohio - OH'},
    {'OK': 'Oklahoma - OK'},
    {'OR': 'Oregon - OR'},
    {'PA': 'Pennsylvania - PA'},
    {'SC': 'South Carolina - SC'},
    {'TN': 'Tennessee - TN'},
    {'VA': 'Virginia - VA'},
    {'WI': 'Wisconsin - WI'}
  ]
